<!-- 3.1 Coût moyen par colis / envoi -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-coins"></i> Coût moyen par colis &amp; par envoi</h3>
    <span class="periode-info" *ngIf="cout">{{ cout.periodeDebut | date:'dd/MM/yy' }} → {{ cout.periodeFin | date:'dd/MM/yy' }}</span>
  </div>
  <div *ngIf="chargement.cout" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.cout && cout">
    <div class="grille-kpi">
      <div class="kpi kpi-warn"><div class="kpi-label">Coût moyen / colis</div><div class="kpi-valeur">{{ cout.coutMoyenParColis | number }} F</div></div>
      <div class="kpi kpi-warn"><div class="kpi-label">Coût moyen / envoi</div><div class="kpi-valeur">{{ cout.coutMoyenParEnvoi | number }} F</div></div>
      <div class="kpi kpi-primary"><div class="kpi-label">Recettes</div><div class="kpi-valeur">{{ cout.recettes | number }} F</div></div>
      <div class="kpi kpi-success"><div class="kpi-label">Marge brute</div><div class="kpi-valeur">{{ cout.margeBrute | number }} F</div></div>
      <div class="kpi kpi-success"><div class="kpi-label">Taux de marge</div><div class="kpi-valeur">{{ cout.tauxMargePct }} %</div></div>
    </div>
    <div style="background:#fef3c7;border-left:4px solid #f59e0b;padding:12px 16px;border-radius:8px;font-size:12px;color:#78350f;">
      <i class="fal fa-info-circle"></i> Les coûts opérationnels sont saisis manuellement dans <strong>Paramètres → Coûts opérationnels</strong> (carburant, main-d'œuvre, centre de tri, autres). Cette page calcule le coût moyen et la marge sur la base des coûts mensuels enregistrés.
    </div>
  </ng-container>
</div>

<!-- 3.2 Coût des anomalies -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-bug"></i> Coût des anomalies</h3>
    <div style="display:flex;gap:10px;align-items:center;">
      <select [(ngModel)]="filtreTypeIncident" (change)="charger()" style="height:30px;padding:0 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;">
        <option [ngValue]="null">Tous types</option>
        <option value="PERTE">Pertes</option>
        <option value="VOL">Vols</option>
        <option value="PRODUIT_ENDOMMAGE">Endommagement</option>
        <option value="ERREUR_ACHEMINEMENT">Erreur d'acheminement</option>
        <option value="RETARD_LIVRAISON">Retard</option>
        <option value="AUTRE">Autres</option>
      </select>
      <span class="periode-info" *ngIf="anomalies">{{ anomalies.periodeDebut | date:'dd/MM/yy' }} → {{ anomalies.periodeFin | date:'dd/MM/yy' }}</span>
    </div>
  </div>
  <div *ngIf="chargement.anomalies" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.anomalies && anomalies">
    <div class="grille-kpi">
      <div class="kpi kpi-danger"><div class="kpi-label">Coût total anomalies</div><div class="kpi-valeur">{{ anomalies.coutTotal | number }} F</div></div>
      <div class="kpi kpi-warn"><div class="kpi-label">Coût moyen / incident</div><div class="kpi-valeur">{{ anomalies.coutMoyenParIncident | number }} F</div></div>
      <div class="kpi"><div class="kpi-label">Incidents avec coût</div><div class="kpi-valeur">{{ anomalies.nbIncidents }}</div></div>
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;">
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Évolution incidents</h4>
        <div echarts [options]="optCoutEvolution" class="chart-container" style="height:260px"></div>
      </div>
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Coût par type d'incident</h4>
        <div echarts [options]="optCoutParType" class="chart-container" style="height:260px"></div>
      </div>
    </div>
  </ng-container>
</div>

<!-- 3.3 Rentabilité par client -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-user-tag"></i> Rentabilité par client</h3>
    <span class="periode-info" *ngIf="rentab">{{ rentab.nbClients }} clients actifs · {{ rentab.nbEnvoisTotal }} envois</span>
  </div>
  <div *ngIf="chargement.rentab" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.rentab && rentab">
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:18px;">
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;"><i class="fal fa-trophy" style="color:#f59e0b;"></i> Top 10 clients</h4>
        <table class="table-rapport">
          <thead><tr><th>Client</th><th style="text-align:right;">CA</th><th style="text-align:right;">Envois</th><th style="text-align:right;">Panier moyen</th></tr></thead>
          <tbody>
            <tr *ngFor="let c of rentab.topClients">
              <td>{{ c.client }}</td>
              <td style="text-align:right;font-weight:600;color:#059669;">{{ c.chiffreAffaires | number }} F</td>
              <td style="text-align:right;">{{ c.nbEnvois }}</td>
              <td style="text-align:right;">{{ c.panierMoyen | number }} F</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;"><i class="fal fa-arrow-down" style="color:#dc2626;"></i> 10 clients à optimiser</h4>
        <table class="table-rapport">
          <thead><tr><th>Client</th><th style="text-align:right;">CA</th><th style="text-align:right;">Envois</th></tr></thead>
          <tbody>
            <tr *ngFor="let c of rentab.bottomClients">
              <td>{{ c.client }}</td>
              <td style="text-align:right;color:#dc2626;">{{ c.chiffreAffaires | number }} F</td>
              <td style="text-align:right;">{{ c.nbEnvois }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>

<!-- 3.4 Tableau de bord financier -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-chart-line"></i> Tableau de bord financier</h3>
    <span class="periode-info" *ngIf="dashboard">{{ dashboard.granularite }}</span>
  </div>
  <div *ngIf="chargement.dashboard" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.dashboard && dashboard">
    <div class="grille-kpi">
      <div class="kpi kpi-success"><div class="kpi-label">Chiffre d'affaires</div><div class="kpi-valeur">{{ dashboard.chiffreAffaires | number }} F</div></div>
      <div class="kpi kpi-primary"><div class="kpi-label">Total encaissé</div><div class="kpi-valeur">{{ dashboard.totalEncaisse | number }} F</div></div>
      <div class="kpi kpi-danger"><div class="kpi-label">Reste à régulariser</div><div class="kpi-valeur">{{ dashboard.resteARegulariser | number }} F</div></div>
    </div>
    <div style="display:grid;grid-template-columns:1.6fr 1fr;gap:18px;">
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Évolution du CA</h4>
        <div echarts [options]="optDashboardSerie" class="chart-container" style="height:280px"></div>
      </div>
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Encaissements par mode</h4>
        <div echarts [options]="optDashboardModes" class="chart-container" style="height:280px"></div>
      </div>
    </div>
  </ng-container>
</div>
